export interface IPanel {
  /** 打开面板 */
  open: () => void
  /** 关闭面板 */
  close: () => void
  /** 更新面板 */
  update: (option: Option) => void
  /** 销毁面板 */
  destroy: () => void
}

// 面板配置项
export type Option = Partial<{
  position: Array<number> // 位置
  type: PanelType // 类型
  title: TitleOption // 标题
  content: ContentOption // 内容
  width: number // 宽度
  height: number // 高度
  bgColor: string // 背景颜色
  bgUrl: string // 背景图片
  borderRadius: number // 圆角
  padding: string // 内边距
  closeable: boolean // 是否显示关闭按钮
  className: string // 自定义类名
  customStyle: object // 自定义样式
  onClose: () => void // 关闭回调
}>

// 面板位置
export type PanelPosition = 'left' | 'right' | 'top' | 'bottom' | 'center'

// 面板类型
export type PanelType = 'info' | 'warning' | 'error' | 'success'

// 标题
export type TitleOption = Partial<{
  value: string
  fontSize: string
  color: string
  fontFamily: string
  fontWeight: number
  lineHeight: number | string
  textAlign: string
  padding: string
  margin: string
  icon: string
}>

// 内容
export type ContentOption = Partial<{
  value: string | HTMLElement
  fontSize: string
  color: string
  fontFamily: string
  fontWeight: number
  lineHeight: string
  textAlign: string
  padding: string
  margin: string
  textIndent: string
}>
